import React, { useContext } from 'react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { WMICVehicleUtil } from 'wmic-pe-portals-utils-js';
import metadata from './WMICPAPolicyVehicleInfo.metadata.json5';
import messages from './WMICPAPolicyVehicleInfo.messages';

function WMICPAPolicyVehicleInfo(props) {
    const { vehicleVM } = props;

    const ViewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    const overrideProps = {
        '@field': {
            parentNode: vehicleVM,
            readOnly: true,
        },
        policyTrailerTitle: {
            title: translator({ id: vehicleVM.vehicleType.value.name }),
        },
        policyVinOverrideReason: {
            value: WMICVehicleUtil.getVinOverrideReasonFallbackValue(vehicleVM, ViewModelService),
        },
    };

    return <ViewModelForm uiProps={metadata.componentContent} model={vehicleVM} overrideProps={overrideProps} />;
}

export default WMICPAPolicyVehicleInfo;
